import task from 'helpers/task'
import inject from 'helpers/inject'

import ApiService from 'services/api'

import getServices from 'tasks/getServices'

export default task(async function() {
  const api = inject(ApiService)
  const keys = await api.request({ url: '/api/keys' })
  const services = await getServices.perform()
  return keys.map(key => {
    key.service = services.find(service => key.service_type === service.id)
    return key
  })
}, {
  defaultValue: []
})



// WEBPACK FOOTER //
// ./src/tasks/getApiKeys.js